export enum JobLogLevel {
  Info = "Info",
  Error = "Error",
  Result = "Result",
}
